import { Box, styled } from '@mui/material';

import { generateAircraftCardItem } from '#test';

import { AirFleetCard } from './AircraftCard';

const PREFIX = 'TSMED-AirFleetCardPreview';

export const AirFleetCardPreviewClasses = {
  root: `${PREFIX}-root`,
} as const;

const Root = styled(Box, {
  name: PREFIX,
  slot: 'Root',
})(() => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 'inherit',
}));

export const AirFleetCardPreview = () => {
  const aircraftCardItem = generateAircraftCardItem('OnGround');

  return (
    <Root>
      <AirFleetCard
        {...aircraftCardItem}
        renderInsideWidget={true}
        onClick={() => {}}
        sx={{
          transform: 'scale(0.62)',
          backgroundColor: 'black',
        }}
      />
    </Root>
  );
};
